  (function () {
    var docEl = document.documentElement;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Scroll-Fortschritt + Header-Schatten */
    var bar = document.createElement('div');
    bar.className = 'fqp-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function onScroll() {
      ticking = false;
      var y = window.scrollY || docEl.scrollTop || 0;
      var max = (docEl.scrollHeight - window.innerHeight) || 1;
      bar.style.setProperty('--fqp-p', Math.min(1, Math.max(0, y / max)).toFixed(4));
      docEl.classList.toggle('fqp-scrolled', y > 8);
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    addEventListener('resize', onScroll);
    onScroll();

    /* Einblenden beim Scrollen – nur Elemente, die beim Laden noch unterhalb des Bildschirms liegen */
    var SEL = [
      '#MainContent .fk-head', '#MainContent .fk-card', '#MainContent .kv-head',
      '#MainContent .fqtp__head', '#MainContent .ks-h', '#MainContent .ks-sub',
      '#MainContent .ks-in details', '#MainContent .sp-sec:not(.sp-hero) .sp-c', '#MainContent .sp-sec:not(.sp-hero) .sp-m',
      '#MainContent .re-h', '#MainContent .hi-h', '#MainContent .oc-title', '#MainContent .fq-h', '#MainContent .fqrv-title',
      '.fq-footer__promise'
    ].join(',');
    function reveal() {
      if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          io.unobserve(el);
          el.classList.add('fqp-in');
          setTimeout(function () { el.classList.add('fqp-done'); el.style.removeProperty('--fqp-d'); }, 1500);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      var vh = window.innerHeight, pending = [];
      /* Sicherung: falls der Observer mal nicht feuert, beim Scrollen selbst nachsehen */
      function sweep() {
        pending = pending.filter(function (el) {
          if (el.classList.contains('fqp-in')) return false;
          if (el.getBoundingClientRect().top < window.innerHeight * 0.96) {
            io.unobserve(el); el.classList.add('fqp-in');
            setTimeout(function () { el.classList.add('fqp-done'); }, 1500);
            return false;
          }
          return true;
        });
        if (!pending.length) removeEventListener('scroll', onSweep);
      }
      var sweepT = null;
      function onSweep() { if (!sweepT) sweepT = setTimeout(function () { sweepT = null; sweep(); }, 150); }
      addEventListener('scroll', onSweep, { passive: true });
      document.querySelectorAll(SEL).forEach(function (el) {
        if (el.closest('.fqb-section, [id*="buybox"], [id^="satc-"], #fqrad')) return;
        if (el.getBoundingClientRect().top < vh * 0.92) return;
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--fqp-d', Math.min(sib, 4) * 0.06 + 's');
        el.classList.add('fqp-rv');
        pending.push(el);
        io.observe(el);
      });
    }

    /* Menueleiste: gleitende Hover-Pille + kleiner Hupfer am Warenkorb-Zaehler */
    function nav() {
      var n = document.querySelector('.shopify-section-group-header-group [class^="ai-shop-header__nav-"]:not([class*="__nav-item"])');
      if (n && !n.querySelector('.fqp-navpill') && window.matchMedia && matchMedia('(hover: hover)').matches) {
        var pill = document.createElement('span');
        pill.className = 'fqp-navpill';
        pill.setAttribute('aria-hidden', 'true');
        n.insertBefore(pill, n.firstChild);
        n.querySelectorAll('a[class*="ai-shop-header__nav-item"]').forEach(function (a) {
          a.addEventListener('mouseenter', function () {
            var nr = n.getBoundingClientRect(), ar = a.getBoundingClientRect();
            if (!pill.classList.contains('is-on')) pill.style.transition = 'opacity .25s';
            pill.style.left = (ar.left - nr.left) + 'px';
            pill.style.width = ar.width + 'px';
            pill.offsetWidth;
            pill.style.transition = '';
            pill.classList.add('is-on');
          });
        });
        n.addEventListener('mouseleave', function () { pill.classList.remove('is-on'); });
      }
      document.querySelectorAll('.shopify-section-group-header-group [class*="ai-shop-header__cart-count"]').forEach(function (c) {
        var last = c.textContent;
        new MutationObserver(function () {
          if (c.textContent === last) return;
          last = c.textContent;
          c.classList.remove('fqp-bump'); c.offsetWidth; c.classList.add('fqp-bump');
        }).observe(c, { childList: true, characterData: true, subtree: true });
      });
    }

    /* Menue: immer nur ein Untermenue offen (PC + Handy), Klick daneben / Esc schliesst */
    function dropdowns() {
      /* Achtung: es gibt mehrere Header-Gruppen-Sections (Laufleiste, Header) – daher document */
      var root = document;
      var WRAP = '[class*="ai-shop-header__nav-item-wrap"]';
      function closeDesktop(except) {
        root.querySelectorAll(WRAP + '.is-open').forEach(function (w) { if (w !== except) w.classList.remove('is-open'); });
      }
      /* Capture-Phase: das Theme stoppt den Klick selbst, danach kaeme unser Listener nicht mehr dran */
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-dropdown-toggle]');
        if (!t || !t.closest('.shopify-section-group-header-group')) return;
        setTimeout(function () {
          var wrap = t.closest(WRAP);
          if (wrap) { closeDesktop(wrap); return; }
          root.querySelectorAll('[class*="ai-shop-header__mobile-nav"] [data-dropdown-toggle].is-open').forEach(function (o) {
            if (o === t) return;
            o.classList.remove('is-open');
            var sub = o.nextElementSibling;
            if (sub && /mobile-sub/.test(sub.className)) sub.classList.remove('is-open');
          });
        }, 0);
      }, true);
      document.addEventListener('click', function (e) { if (!e.target.closest(WRAP)) closeDesktop(null); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDesktop(null); });
    }

    /* Trenner direkt unter der weissen Buy Box oben ebenfalls weiss, sonst sieht man eine Kante */
    function seams() {
      document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s) {
        if (!s.querySelector('.fqb-section, .fqb-buybox')) return;
        var n = s.nextElementSibling;
        while (n && !n.offsetHeight) n = n.nextElementSibling;
        if (!n || !/section_divider|section-divider/.test(n.id)) return;
        var bb = s.querySelector('.fqb-buybox') || s.querySelector('.fqb-section');
        var col = getComputedStyle(bb).backgroundColor;
        n.querySelectorAll('[class*="top-padding"], .section-divider').forEach(function (el) {
          el.style.setProperty('background-color', col, 'important');
        });
      });
    }

    /* Drei gezeichnete Katzen als Deko (aria-hidden, keine Klickflaeche) */
    var CAT_SIT = '<svg viewBox="0 0 70 92"><path class="fqp-c-line fqp-c-tail" d="M50 84 C66 84 70 70 62 60"/>' +
      '<path class="fqp-c-fill" d="M20 88 C10 74 12 54 22 44 C17 37 17 28 21 21 L19 6 L30 14 C34 12.8 38 12.8 42 14 L53 6 L51 21 C55 28 55 37 50 44 C60 54 62 74 52 88 Z"/>' +
      '<ellipse class="fqp-c-eye" cx="30" cy="28" rx="2.2" ry="3"/><ellipse class="fqp-c-eye" cx="42" cy="28" rx="2.2" ry="3"/>' +
      '<path class="fqp-c-nose" d="M34.5 33 h3 l-1.5 1.8z"/><path class="fqp-c-thin" d="M36 35 q-2 2 -4 1 M36 35 q2 2 4 1"/>' +
      '<path class="fqp-c-thin" d="M26 34 h-9 M26 36.5 l-8 2 M46 34 h9 M46 36.5 l8 2"/><path class="fqp-c-thin" d="M30 55 q6 5 12 0"/>' +
      '<path class="fqp-c-line" d="M30 88 v-8 M42 88 v-8"/></svg>';
    var CAT_PEEK = '<svg viewBox="0 0 120 64"><path class="fqp-c-fill" d="M30 34 L28 8 L50 22 Z"/><path class="fqp-c-fill" d="M90 34 L92 8 L70 22 Z"/>' +
      '<path class="fqp-c-thin" d="M33 27 L32 15 L43 22 M87 27 L88 15 L77 22"/>' +
      '<path class="fqp-c-fill" d="M26 64 C24 36 40 20 60 20 C80 20 96 36 94 64 Z"/>' +
      '<ellipse class="fqp-c-eye" cx="46" cy="42" rx="3.2" ry="4.5"/><ellipse class="fqp-c-eye" cx="74" cy="42" rx="3.2" ry="4.5"/>' +
      '<path class="fqp-c-nose" d="M57 50 h6 l-3 3z"/><path class="fqp-c-thin" d="M60 53 q-3 4 -7 2 M60 53 q3 4 7 2"/>' +
      '<path class="fqp-c-thin" d="M40 50 h-14 M40 54 l-13 3 M80 50 h14 M80 54 l13 3"/>' +
      '<ellipse class="fqp-c-fill" cx="40" cy="63" rx="10" ry="6"/><ellipse class="fqp-c-fill" cx="80" cy="63" rx="10" ry="6"/>' +
      '<path class="fqp-c-thin" d="M36 61 v3 M40 60.5 v3 M44 61 v3 M76 61 v3 M80 60.5 v3 M84 61 v3"/></svg>';
    var CAT_SLEEP = '<svg viewBox="0 0 140 72">' +
      '<path class="fqp-c-fill fqp-c-body" d="M18 71 C16 44 44 28 78 30 C110 32 128 48 126 71 Z"/>' +
      '<path class="fqp-c-thin" d="M84 34 q4 8 0 14 M96 36 q4 8 0 14 M108 42 q3 6 0 11"/>' +
      '<path d="M122 64 C132 72 100 76 70 71" fill="none" stroke="#eca841" stroke-width="8" stroke-linecap="round"/>' +
      '<path d="M122 64 C132 72 100 76 70 71" fill="none" stroke="#fff6e8" stroke-width="3.6" stroke-linecap="round"/>' +
      '<path class="fqp-c-fill" d="M22 46 L20 29 L33 38 Z"/><path class="fqp-c-fill" d="M42 36 L52 28 L51 44 Z"/>' +
      '<circle class="fqp-c-fill" cx="36" cy="53" r="17"/>' +
      '<path class="fqp-c-line" style="stroke-width:1.8" d="M27 53 q3 3 6 0 M39 53 q3 3 6 0"/><path class="fqp-c-nose" d="M34.5 58 h3 l-1.5 1.6z"/>' +
      '<text class="fqp-c-z" x="50" y="22">z</text><text class="fqp-c-z" x="58" y="14">z</text><text class="fqp-c-z" x="64" y="7">z</text></svg>';

    var CAT_HANG = '<svg viewBox="0 0 130 60">' +
      '<path class="fqp-c-line fqp-c-tail" style="stroke-width:5" d="M110 42 C117 45 119 53 115 59"/>' +
      '<path class="fqp-c-fill" d="M24 44 C24 30 44 24 70 24 C96 24 112 30 112 44 Z"/>' +
      '<path class="fqp-c-thin" d="M66 28 q3 6 0 12 M78 28 q3 6 0 12 M90 30 q3 5 0 10"/>' +
      '<path class="fqp-c-fill" d="M17 27 L14 13 L25 21 Z"/><path class="fqp-c-fill" d="M30 21 L39 12 L38 26 Z"/>' +
      '<circle class="fqp-c-fill" cx="26" cy="34" r="13"/>' +
      '<path class="fqp-c-line" style="stroke-width:1.8" d="M19.5 34.5 q2.5 -2.6 5 0 M28 34.5 q2.5 -2.6 5 0"/><path class="fqp-c-nose" d="M24.8 38.4 h2.6 l-1.3 1.5z"/>' +
      '<path class="fqp-c-fill" d="M18 44 h8 v6 a4 4 0 0 1 -8 0 z"/><path class="fqp-c-fill" d="M30 44 h8 v5 a4 4 0 0 1 -8 0 z"/></svg>';
    var CAT_WALK = '<svg viewBox="0 0 120 70">' +
      '<path class="fqp-c-line fqp-c-tail2" style="stroke-width:5" d="M22 38 C10 34 7 21 15 14"/>' +
      '<path class="fqp-c-line" style="stroke-width:5" d="M31 44 L29 62 M41 44 L43 62 M74 44 L72 62 M84 44 L86 62"/>' +
      '<path class="fqp-c-fill" d="M20 38 C20 28 34 24 52 25 L80 25 C88 25 92 29 92 35 C92 43 86 46 80 46 L30 46 C24 46 20 43 20 38 Z"/>' +
      '<path class="fqp-c-thin" d="M48 28 q3 6 0 12 M60 27 q3 6 0 12"/>' +
      '<path class="fqp-c-fill" d="M88 20 L87 8 L96 16 Z"/><path class="fqp-c-fill" d="M100 16 L107 7 L107 21 Z"/>' +
      '<circle class="fqp-c-fill" cx="97" cy="27" r="12"/>' +
      '<ellipse class="fqp-c-eye" cx="101" cy="25.5" rx="1.8" ry="2.4"/><path class="fqp-c-nose" d="M106.5 29.5 l2.6 -.6 -.9 2z"/>' +
      '<path class="fqp-c-thin" d="M104 32 h10 M104 34 l9 2"/></svg>';

    function cats() {
      if (docEl.classList.contains('fqp-cats-done')) return;
      docEl.classList.add('fqp-cats-done');
      function mk(cls, svg) {
        var s = document.createElement('span');
        s.className = 'fqp-cat ' + cls;
        s.setAttribute('aria-hidden', 'true');
        s.innerHTML = svg;
        return s;
      }
      function rel(el) { if (getComputedStyle(el).position === 'static') el.style.position = 'relative'; }
      /* Startbild-Karte: Katze liegt ausgestreckt oben drauf */
      var heroCard = document.querySelector('#MainContent .fqp-hero-quote') || document.querySelector('#MainContent .sp-hero .sp-c');
      if (heroCard) { rel(heroCard); heroCard.appendChild(mk('fqp-cat--hang', CAT_HANG)); }
      /* Kategorie-Kartenreihe: sitzende Katze (nur wenn die Reihe nicht seitlich scrollt) */
      var grid = document.querySelector('#MainContent .fk-grid');
      if (grid) {
        var gs = getComputedStyle(grid);
        if (gs.overflowX === 'visible' && gs.overflowY === 'visible') { rel(grid); grid.appendChild(mk('fqp-cat--sit', CAT_SIT)); }
      }
      /* "6 Gruende": sitzende Katze auf der Box */
      var reWrap = document.querySelector('#MainContent .re-wrap');
      if (reWrap && !grid) { rel(reWrap); reWrap.appendChild(mk('fqp-cat--sit fqp-cat--sit-re', CAT_SIT)); }
      /* Bewertungen: laufende Katze (erste Bewertungs-Section der Seite) */
      var tpHead = document.querySelector('#MainContent .fqtp__head');
      if (tpHead) { rel(tpHead); tpHead.appendChild(mk('fqp-cat--walk', CAT_WALK)); }
      /* FAQ: lugt ueber die erste Frage (Startseite/SchnurrBrunnen .ks-in, PfotenBrunnen .fq-w) */
      var faq = document.querySelector('#MainContent .ks-in') || document.querySelector('#MainContent .fq-w');
      var first = faq && faq.querySelector('details');
      if (first) {
        rel(faq);
        var peek = mk('fqp-cat--peek', CAT_PEEK);
        faq.appendChild(peek);
        /* Ueberschrift, die bis an die Katze reicht (z. B. schmale FAQ): darunter Platz schaffen, damit die Katze nichts verdeckt */
        var fh = [].slice.call(faq.querySelectorAll('h2, .fq-h, .ks-h')).filter(function (h) { return !first.contains(h); })[0];
        var place = function () {
          if (fh) fh.style.removeProperty('margin-bottom');
          var top = first.getBoundingClientRect().top - faq.getBoundingClientRect().top;
          peek.style.top = (top - peek.offsetHeight + 3) + 'px';
          if (!fh) return;
          var pr = peek.getBoundingClientRect(), hr = fh.getBoundingClientRect();
          var overlapX = pr.left < hr.right && pr.right > hr.left;
          var overlapY = hr.bottom - pr.top;
          if (overlapX && overlapY > 0) {
            var mb = parseFloat(getComputedStyle(fh).marginBottom) || 0;
            fh.style.setProperty('margin-bottom', (mb + overlapY + 8) + 'px', 'important');
            top = first.getBoundingClientRect().top - faq.getBoundingClientRect().top;
            peek.style.top = (top - peek.offsetHeight + 3) + 'px';
          }
        };
        place();
        addEventListener('resize', place);
        if (window.ResizeObserver) new ResizeObserver(place).observe(faq);
      }
      /* Footer: schlaeft auf der Garantie-Karte */
      var promise = document.querySelector('.fq-footer__promise');
      if (promise) promise.appendChild(mk('fqp-cat--sleep', CAT_SLEEP));
    }

    /* Neutrale Grau-Flaechen der Sections (inkl. Wellen-Trenner) auf warmes Creme umfaerben */
    function warmGrays() {
      var WARM = '#f5eadc';
      function gray(c) {
        var m = /rgba?\((\d+), (\d+), (\d+)(?:, ([\d.]+))?/.exec(c || '');
        if (!m || (m[4] !== undefined && +m[4] < 0.9)) return false;
        var r = +m[1], g = +m[2], b = +m[3], mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        return mx - mn <= 6 && mx >= 225 && mx <= 248;
      }
      document.querySelectorAll('#MainContent .shopify-section > section, #MainContent .shopify-section > div, #MainContent [id*="section_divider"] *, #MainContent [id*="section-divider"] *').forEach(function (el) {
        if (el.closest('.fqb-section, [id*="buybox"]')) return;
        var cs = getComputedStyle(el);
        if (gray(cs.backgroundColor)) el.style.setProperty('background-color', WARM, 'important');
        if (el instanceof SVGElement) {
          if (gray(cs.color)) el.style.setProperty('color', WARM, 'important');
          if (gray(cs.fill)) el.style.setProperty('fill', WARM, 'important');
        }
      });
      /* Der Theme-Hauch rgba(31,43,58,a) (blaeulich-grau) auf Kacheln/Platzhaltern -> zartes Orange */
      var run = function () {
        document.querySelectorAll('#MainContent *').forEach(function (el) {
          if (el.closest('.fqb-section, [id*="buybox"]')) return;
          var m = /rgba\(31, 43, 58, ([\d.]+)\)/.exec(getComputedStyle(el).backgroundColor);
          if (m && +m[1] <= 0.2) el.style.setProperty('background-color', 'rgba(236, 168, 65, ' + Math.min(0.18, +m[1] * 2).toFixed(3) + ')', 'important');
        });
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 1500 }); else setTimeout(run, 300);
    }

    /* Produktseiten: Abschnitte unter der Buy Box als Karten anordnen */
    function productPanels() {
      /* Produktseiten (ab der Buy Box) und – seit 28.09. – Startseite (ab dem Startbild) */
      var PP = docEl.classList.contains('fqp-pp'), HP = docEl.classList.contains('fqp-hp');
      /* Salesseite (29.09.): Buy Box steht mittendrin -> Toene schon ab dem Startbild */
      var SALES = docEl.classList.contains('fqp-sales');
      /* 07.10.: Salesseite ohne Startbild (Buy Box ganz oben) -> genau wie die Brunnenseiten ab der Buy Box toenen */
      if (SALES && !document.querySelector('#MainContent > [id$="__hero"]')) SALES = false;
      if (!PP && !HP) return;
      var secs = [].slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
      var start = -1;
      secs.forEach(function (s, i) {
        if (SALES) { if (start < 0 && /__hero$/.test(s.id)) start = i; return; }
        if (PP && (s.querySelector('.fqb-section, .fqb-buybox, [class*="buybox"]') || /buybox/.test(s.id))) start = i;
        if (HP && start < 0 && /__hero$/.test(s.id)) start = i;
      });
      if (start < 0) return;
      function type(s) { return (s.id.split('__')[1] || '').replace(/_[A-Za-z0-9]{6}$/, '').replace(/\d+$/, ''); }
      var list = [], seq = [];
      secs.slice(start + 1).forEach(function (s) {
        if (/divider/.test(s.id)) { seq.push({ div: s }); return; }
        if (!s.offsetHeight || /sticky|faq_reviews/.test(s.id) || (SALES && /__trust$/.test(s.id))) return;
        var el = [].slice.call(s.children).filter(function (c) { return /^(SECTION|DIV)$/.test(c.tagName) && c.offsetHeight > 20; })[0];
        if (!el) return;
        var it = { s: s, el: el, t: type(s) };
        list.push(it); seq.push(it);
      });
      if (!list.length) return;
      var PAIRS = { offer_cta: /^fq_bewertungen/, ks_faq: /^ks_cta/, fq_gruender: /^fq_trustpilot/, health_insight: /^nuppy_vergleich/ };
      /* Nutzerwunsch: nicht viele Farben, alles aus einem Guss -> nur ZWEI Toene im Wechsel
         (Weiss + das Creme der Buy Box); Abwechslung kommt ueber Wellen, gruene Plaketten, Icons, Katzen. */
      var BUY = '#fdf6ec', WHITE = '#ffffff', DARK = '';
      var PREF = {};
      /* Startseite (29.09.): drei Toene Weiss / Salbei / Creme, feste Zuordnung fuer die Theme-Abschnitte */
      if (HP) PREF = { video_testimonials: WHITE, bewertungen: WHITE, ks_faq: WHITE };
      /* Produktseiten (29.09.): Angebot + Bewertungen in Sand */
      if (PP) PREF = { offer_cta: '#f8ecdb' };
      if (SALES) PREF = { buybox: BUY };
      var CYCLE = [WHITE, BUY];
      var prevCol = BUY, ci = 0;
      list.forEach(function (it, i) {
        var prev = list[i - 1];
        var join = prev && (prev.t === it.t || (PAIRS[prev.t] && PAIRS[prev.t].test(it.t)));
        if (join) { prev.s.classList.add('fqp-jb'); it.s.classList.add('fqp-jt'); it.col = prev.col; }
        else {
          /* Startseite: FQ-Startseite-Abschnitte bringen ihren Ton selbst mit (data-fqs-bg) */
          var own = it.el.getAttribute('data-fqs-bg') || (/^(fq_gruender|fq_trustpilot)/.test(it.t) ? WHITE : '');
          var c = own || PREF[it.t];
          /* Videos direkt unter der Buy Box: gleicher Ton -> nahtloser Uebergang ohne Kante */
          if (PP && !SALES && i === 0 && /video_testimonials/.test(it.t)) c = BUY;
          else if (!own && (!c || c === prevCol)) {
            for (var k = 0; k < CYCLE.length; k++) { c = CYCLE[(ci + k) % CYCLE.length]; if (c !== prevCol) { ci = (ci + k + 1) % CYCLE.length; break; } }
          }
          it.col = c;
        }
        prevCol = it.col;
        it.s.classList.add('fqp-ps');
        it.el.classList.add('fqp-pan');
        it.el.style.setProperty('background-color', it.col, 'important');
        it.el.style.setProperty('background-image', 'none', 'important');
        if (it.col === DARK) it.el.classList.add('fqp-dark');
      });
      list[0].s.classList.add('fqp-first');
      list[list.length - 1].s.classList.add('fqp-last');

      /* Wellen-Trenner – eine Regel fuer alle Produktseiten:
         - an JEDEM Farbwechsel dieselbe Welle (Kopie EINER Vorlage -> gleiche Form und Hoehe ueberall)
         - direkt am Video-Abschnitt keine Welle
         - oben Farbe darueber, Welle + unten Farbe darunter (per Inline-Style, gewinnt gegen die Herbst-Toenung) */
      function tone(it) { return it.col; }
      function paint(el, prop, val) { el.style.setProperty(prop, val, 'important'); }
      var dividers = seq.filter(function (x) { return x.div; }).map(function (x) { return x.div; });
      var tpl = dividers[0] || document.querySelector('#MainContent > .shopify-section[id*="divider"]');
      dividers.forEach(function (dv) { dv.classList.add('fqp-div'); });
      if (!tpl) return;
      function isVideo(it) { return /video_testimonials/.test(it.t); }
      /* Startseite (29.09.): abwechselnde Uebergaenge statt ueberall Wellen */
      var sepN = 0;
      var SHAPES = ['wave', 'arc', 'slant', 'curve', 'slantR', 'arc', 'wave'];
      var PATHS = {
        arc: 'M0,100 Q720,-60 1440,100 Z',
        curve: 'M0,0 Q720,150 1440,0 L1440,100 L0,100 Z',
        slant: 'M0,100 L1440,0 L1440,100 Z',
        slantR: 'M0,0 L1440,100 L0,100 Z'
      };
      function sep(beforeEl, top, bottom, n) {
        var shape = SHAPES[n % SHAPES.length];
        if (shape === 'wave') { wave(beforeEl, top, bottom); return; }
        var d = document.createElement('div');
        d.className = 'shopify-section fqp-sep fqp-sep--' + shape;
        d.setAttribute('aria-hidden', 'true');
        paint(d, 'background-color', top);
        d.innerHTML = '<svg viewBox="0 0 1440 100" preserveAspectRatio="none"><path d="' + PATHS[shape] + '"/></svg>';
        paint(d.querySelector('path'), 'fill', bottom);
        beforeEl.parentNode.insertBefore(d, beforeEl);
      }
      function wave(beforeEl, top, bottom) {
        var w = tpl.cloneNode(true);
        w.removeAttribute('id');
        w.classList.remove('fqp-div');
        w.classList.add('fqp-wave');
        w.setAttribute('aria-hidden', 'true');
        w.querySelectorAll('div').forEach(function (el) {
          paint(el, 'background-color', /bottom-padding/.test(el.className) ? bottom : top);
        });
        w.querySelectorAll('svg, svg *').forEach(function (el) { paint(el, 'color', bottom); paint(el, 'fill', bottom); });
        beforeEl.parentNode.insertBefore(w, beforeEl);
      }
      list.forEach(function (it, i) {
        var prev = list[i - 1];
        var topTone = prev ? tone(prev) : BUY;            /* ueber dem ersten Abschnitt liegt die cremefarbene Buy Box */
        if (topTone === tone(it)) return;                  /* kein Farbwechsel -> gerade Fortsetzung */
        if (PP && !SALES && isVideo(it)) return;           /* Produktseite: ueber dem Video-Abschnitt bewusst keine Welle */
        sep(it.s, topTone, tone(it), sepN++);
      });
    }

    function menuCat() {
      var mc = document.querySelector('.shopify-section-group-header-group [class*="ai-shop-header__mobile-content"]');
      if (!mc || mc.querySelector('.fqp-menu-cat')) return;
      var c = document.createElement('span');
      c.className = 'fqp-cat fqp-cat--sleep fqp-menu-cat';
      c.setAttribute('aria-hidden', 'true');
      c.innerHTML = CAT_SLEEP;
      mc.appendChild(c);
    }

    function menuState() {
      var m = document.querySelector('.shopify-section-group-header-group [class*="ai-shop-header__mobile-menu"]');
      if (!m || !('MutationObserver' in window)) return;
      var sync = function () { docEl.classList.toggle('fqp-menu-open', /mobile-menu--open/.test(m.className)); };
      new MutationObserver(sync).observe(m, { attributes: true, attributeFilter: ['class'] });
      sync();
    }

    /* Icons (Linien-Stil) – Vorbild trinktiger.de. Nur Deko, Inhalte bleiben gleich. */
    var ICO = {
      home: '<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h14V9.5"/><path d="M10 20v-6h4v6"/>',
      drop: '<path d="M12 2.8S6 9.1 6 14a6 6 0 0 0 12 0c0-4.9-6-11.2-6-11.2z"/><path d="M9.5 14.5a2.5 2.5 0 0 0 2.5 2.5"/>',
      filter: '<path d="M3 4h18l-7 8.5V19l-4 2v-8.5z"/>',
      box: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m3 8 9 5 9-5"/><path d="M12 13v8"/>',
      heart: '<path d="M12 20s-7.5-4.6-9.2-9.1C1.5 7.6 3.7 4.8 6.8 4.8c2.1 0 3.5 1.2 5.2 3 1.7-1.8 3.1-3 5.2-3 3.1 0 5.3 2.8 4 6.1C19.5 15.4 12 20 12 20z"/>',
      paw: '<circle cx="6.5" cy="10" r="1.9"/><circle cx="10" cy="5.8" r="1.9"/><circle cx="14" cy="5.8" r="1.9"/><circle cx="17.5" cy="10" r="1.9"/><path d="M8 17.2c0-2.8 1.8-5.2 4-5.2s4 2.4 4 5.2c0 1.6-1.2 2.3-2.4 2.3-.8 0-1-.4-1.6-.4s-.8.4-1.6.4C9.2 19.5 8 18.8 8 17.2z"/>',
      truck: '<path d="M3 6h11v10H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/>',
      shield: '<path d="M12 3 4.5 6v5.5c0 4.5 3.2 8 7.5 9.5 4.3-1.5 7.5-5 7.5-9.5V6z"/><path d="m9 12 2 2 4-4"/>',
      sound: '<path d="M4 9v6h4l5 4V5L8 9z"/><path d="M16.5 9.5a4 4 0 0 1 0 5"/><path d="M19 7a7.5 7.5 0 0 1 0 10"/>',
      spark: '<path d="M12 3l1.8 4.7 4.7 1.8-4.7 1.8L12 16l-1.8-4.7-4.7-1.8 4.7-1.8z"/><path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>',
      battery: '<rect x="3" y="7" width="16" height="10" rx="2"/><path d="M21 11v2"/><path d="M6.5 10v4M10 10v4"/>',
      clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
      cat: '<path d="M5 20V9.5L4 3.5l4.5 3h7l4.5-3-1 6V20z"/><path d="M9.5 12.5h.01M14.5 12.5h.01"/><path d="M11 15.5h2l-1 1z"/>',
      calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
      users: '<circle cx="9" cy="8" r="3"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"/><path d="M16 5a3 3 0 0 1 0 6M21 20c0-2.6-1.6-4.8-4-5.6"/>',
      star: '<path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/>',
      question: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.5v.4"/><path d="M12 17h.01"/>',
      play: '<circle cx="12" cy="12" r="9"/><path d="m10 8.5 5.5 3.5-5.5 3.5z"/>',
      quote: '<path d="M6 17c2.5-1 4-3 4-6V7H5v5h3M15 17c2.5-1 4-3 4-6V7h-5v5h3"/>',
      layers: '<path d="m12 3 9 5-9 5-9-5z"/><path d="m3 13 9 5 9-5"/>'
    };
    function svgIco(name) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICO[name] || ICO.paw) + '</svg>';
    }
    function tile(name, cls) {
      var s = document.createElement('span');
      s.className = 'fqp-ico ' + (cls || '');
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = svgIco(name);
      return s;
    }
    function pickFaq(t) {
      t = t.toLowerCase();
      var R = [
        [/filter/, 'filter'], [/laut|leise|geräusch/, 'sound'], [/reinig|sauber|spül|schmierig/, 'spark'],
        [/sicher|plastik|material|bpa/, 'shield'], [/akku|lade|strom|kabel/, 'battery'],
        [/aufbau|aufwendig|dauert|wie lange|oft/, 'clock'], [/paket|enthalten|lieferumfang|im paket/, 'box'],
        [/versand|liefer|bestell/, 'truck'], [/garantie|zurück|rückgabe|risiko/, 'shield'],
        [/wasser|leitungs|trink/, 'drop'], [/katze|annimmt|nimmt/, 'cat'], [/seit wann|gibt es/, 'calendar'],
        [/wer steckt|team|hinter/, 'users'], [/warum|marke|kaufen/, 'star'], [/betriebsart|modus|funktion/, 'layers']
      ];
      for (var i = 0; i < R.length; i++) if (R[i][0].test(t)) return R[i][1];
      return 'question';
    }
    function icons() {
      /* FAQ-Fragen (Startseite/SchnurrBrunnen: .ks-in, PfotenBrunnen: .fq-i) */
      document.querySelectorAll('#MainContent .ks-in details > summary, #MainContent .fq-i > summary').forEach(function (s) {
        if (s.querySelector('.fqp-ico')) return;
        s.classList.add('fqp-has-qi');
        s.insertBefore(tile(pickFaq(s.textContent), 'fqp-qi'), s.firstChild);
      });
      /* Handymenue: Icons statt Nummern */
      var MAP = [[/home|start/i, 'home'], [/brunnen/i, 'drop'], [/zubeh|filter/i, 'filter'], [/familie|kontakt|über/i, 'heart']];
      document.querySelectorAll('.shopify-section-group-header-group a[class*="ai-shop-header__mobile-nav-item"]').forEach(function (a) {
        if (a.querySelector('.fqp-ico')) return;
        var t = a.textContent, n = 'paw';
        MAP.some(function (m) { if (m[0].test(t)) { n = m[1]; return true; } });
        a.classList.add('fqp-has-mi');
        a.insertBefore(tile(n, 'fqp-mi'), a.firstChild);
      });
      /* Aufklapp-Menues am PC */
      var DMAP = [[/brunnen/i, 'drop'], [/filter/i, 'filter'], [/unterlage|matte/i, 'layers'], [/verfolg|versand|bestell/i, 'truck'], [/kontakt/i, 'heart']];
      document.querySelectorAll('.shopify-section-group-header-group a[class*="ai-shop-header__dropdown-link"]').forEach(function (a) {
        if (a.querySelector('.fqp-ico')) return;
        var t = a.textContent, n = 'paw';
        DMAP.some(function (m) { if (m[0].test(t)) { n = m[1]; return true; } });
        a.insertBefore(tile(n, 'fqp-di'), a.firstChild);
      });
      /* runde Icon-Plakette ueber zentrierten Ueberschriften */
      [['.kv-title', 'play'], ['.re-h', 'paw'], ['.ks-h', 'question'], ['.fq-h', 'question']].forEach(function (p) {
        document.querySelectorAll('#MainContent ' + p[0]).forEach(function (h) {
          if (h.previousElementSibling && h.previousElementSibling.classList.contains('fqp-badge')) return;
          h.parentNode.insertBefore(tile(p[1], 'fqp-badge'), h);
        });
      });
      /* Zitat-Icon in Bewertungskarten */
      document.querySelectorAll('#MainContent .fqtp__card').forEach(function (c) {
        if (c.querySelector('.fqp-quote')) return;
        c.appendChild(tile('quote', 'fqp-quote'));
      });
    }

    /* FAQ am Handy: nach 5 Fragen "Mehr anzeigen" (am PC bleibt alles offen sichtbar) */
    function faqMore() {
      [['.ks-in', 'details'], ['.fq-w', '.fq-i']].forEach(function (p) {
        document.querySelectorAll('#MainContent ' + p[0]).forEach(function (box) {
          if (box.querySelector('.fqp-more')) return;
          var items = [].slice.call(box.querySelectorAll(p[1]));
          if (items.length <= 6) return;
          items.slice(5).forEach(function (it) { it.classList.add('fqp-faq-x'); });
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fqp-more';
          b.innerHTML = 'Mehr anzeigen <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
          b.addEventListener('click', function () { box.classList.add('fqp-faq-all'); });
          box.appendChild(b);
        });
      });
    }

    /* Footer-Uebergang: Farbe des letzten Abschnitts fuer Girlande + Welle uebernehmen */
    function footerWave() {
      var hero = document.querySelector('.fq-footer__hero');
      var foot = hero && hero.closest('.fq-footer');
      if (!foot || foot.classList.contains('fqp-fw')) return;
      var secs = [].slice.call(document.querySelectorAll('#MainContent > .shopify-section')).filter(function (s) { return s.offsetHeight > 20; });
      var last = secs[secs.length - 1], col = '';
      var pan = last && last.querySelector('.fqp-pan');
      if (pan) col = getComputedStyle(pan).backgroundColor;
      else if (last) {
        [last].concat([].slice.call(last.querySelectorAll('section, div'))).some(function (el) {
          var c = getComputedStyle(el).backgroundColor;
          if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') { col = c; return true; }
          return false;
        });
      }
      if (!col) col = getComputedStyle(document.body).backgroundColor;
      /* Girlande entsteht erst im Herbst-Skript (laeuft nach diesem) -> kurz danach einfaerben */
      var paintG = function () { var g = document.querySelector('.fqh-garland'); if (g) g.style.setProperty('background-color', col, 'important'); return !!g; };
      if (!paintG()) { setTimeout(paintG, 0); setTimeout(paintG, 300); }
      foot.style.setProperty('--fqp-fw-col', col);
      foot.classList.add('fqp-fw');
    }

    /* Trustpilot-Sterne rechts neben dem Produkttitel; Klick springt zu den Bewertungen */
    function tpStars() {
      var h = document.querySelector('.fqb-section .fqb-title') || document.querySelector('.kb-buybox .kb-title');
      if (!h || document.querySelector('.fqp-tp')) return;
      var star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#fff" d="m12 2.8 2.7 6.2 6.7.6-5.1 4.4 1.6 6.6L12 17.1l-5.9 3.5 1.6-6.6-5.1-4.4 6.7-.6z"/></svg>';
      var row = document.createElement('div');
      row.className = 'fqp-titlerow';
      h.parentNode.insertBefore(row, h);
      row.appendChild(h);
      var a = document.createElement('span');
      a.className = 'fqp-tp';
      a.setAttribute('role', 'img');
      a.setAttribute('aria-label', '4,5 von 5 auf Trustpilot');
      a.innerHTML = '<span class="fqp-tp__stars">' + new Array(6).join('<span>' + star + '</span>') + '</span>' +
        '<span class="fqp-tp__txt">4,5 von 5 auf Trustpilot</span>';
      row.appendChild(a);
      var fit = function () {
        a.classList.remove('fqp-tp--below');
        if (a.getBoundingClientRect().top > h.getBoundingClientRect().top + 12) a.classList.add('fqp-tp--below');
      };
      fit();
      addEventListener('resize', fit);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    }

    /* Startbild: Bewertungskarte mit einer echten Bewertung von der Seite (erste Trustpilot-Karte) */
    function heroQuote() {
      var card = document.querySelector('#MainContent .sp-hero .sp-c');
      var src = document.querySelector('#MainContent .fqtp__card');
      if (!card || !src || card.querySelector('.fqp-hero-quote')) return;
      var txtEl = src.querySelector('.fqtp__text'), nameEl = src.querySelector('.fqtp__name');
      if (!txtEl || !nameEl) return;
      var t = txtEl.textContent.replace(/\s+/g, ' ').trim();
      if (t.length > 120) t = t.slice(0, 117).replace(/\s+\S*$/, '') + ' …';
      var q = document.createElement('div');
      q.className = 'fqp-hero-quote';
      var p = document.createElement('p'); p.className = 'fqp-hero-quote__t'; p.textContent = '„' + t.replace(/^[„"]+|[“"]+$/g, '') + '“';
      var m = document.createElement('div'); m.className = 'fqp-hero-quote__m';
      m.innerHTML = '<span class="fqp-hero-quote__s" aria-hidden="true">★★★★★</span>';
      var n = document.createElement('span'); n.textContent = nameEl.textContent.trim(); m.appendChild(n);
      var v = document.createElement('span'); v.className = 'fqp-hero-quote__v'; v.textContent = 'Trustpilot'; m.appendChild(v);
      q.appendChild(p); q.appendChild(m);
      /* Split-Layout: Bewertung haengt unten links am Foto */
      var media = document.documentElement.classList.contains('fqp-hsplit') && document.querySelector('#MainContent .sp-hero .sp-m');
      (media || card).appendChild(q);
    }

    /* Filterseite: Preis + Preis pro Filter in die Pack-Kacheln, guenstigster pro Filter = "Bester Preis" (Werte aus den Variantendaten der Section) */
    function filterTiles() {
      if (!docEl.classList.contains('fqp-filterpage')) return;   /* nur Filterseite (Template filterset) – PfotenBrunnen nutzt dieselbe Section */
      var sec = document.querySelector('#MainContent [id*="kittyspout_buybox"]');
      if (!sec) return;
      var dEl = sec.querySelector('script[id^="fqb-data-"]'); if (!dEl) return;
      var d; try { d = JSON.parse(dEl.textContent); } catch (e) { return; }
      var num = function (s) { return parseFloat(String(s).replace(/[^\d,]/g, '').replace(',', '.')); };
      var fmt = function (n) { return '€' + n.toFixed(2).replace('.', ','); };
      var tiles = [].slice.call(sec.querySelectorAll('.fqb-tile[data-fqb-optval]')).filter(function (t) { return /(\d+)er/.test(t.getAttribute('data-fqb-optval')); });
      if (!tiles.length) return;
      tiles[0].closest('.fqb-seg').classList.add('fqp-packs');
      var best = null, bestPer = 1e9;
      tiles.forEach(function (t) {
        var ov = t.getAttribute('data-fqb-optval');
        var v = d.filter(function (x) { return x.options && x.options[0] === ov && x.available; })[0] || d.filter(function (x) { return x.options && x.options[0] === ov; })[0];
        if (!v) return;
        var n = +(/(\d+)er/.exec(ov)[1]), p = num(v.price), per = p / n;
        if (!(p > 0)) return;
        [].slice.call(t.querySelectorAll('.fqp-tprice,.fqp-tper,.fqp-tbadge')).forEach(function (x) { x.remove(); });
        t.insertAdjacentHTML('beforeend', '<span class="fqp-tprice">' + fmt(p) + '</span><span class="fqp-tper">' + fmt(per) + ' / Filter</span>');
        if (per < bestPer) { bestPer = per; best = t; }
      });
      if (best) best.insertAdjacentHTML('afterbegin', '<span class="fqp-tbadge">Bester Preis</span>');
      if (!sec.__fqpTiles) {
        sec.__fqpTiles = true;
        sec.addEventListener('click', function () { setTimeout(function () { if (!sec.querySelector('.fqp-tprice')) filterTiles(); }, 60); });
      }
    }

    /* Brunnenseiten: "…Brunnen" im Titel orange + Wellenlinie; Label "Unser meistgekaufter Brunnen" nur beim PfotenBrunnen */
    function titleStyle() {
      if (!docEl.classList.contains('fqp-pp') || docEl.classList.contains('fqp-filterpage')) return;
      var t = document.querySelector('#MainContent .fqb-title');
      if (!t || t.getAttribute('data-fqp-tt')) return;
      t.setAttribute('data-fqp-tt', '1');
      var txt = t.textContent.trim();
      var m = /^(.*?)(brunnen)$/i.exec(txt);
      if (m && m[1]) {
        t.textContent = m[1];
        var b = document.createElement('span'); b.className = 'fqp-tt-b'; b.textContent = m[2];
        t.appendChild(b);
      }
      if (/pfoten/i.test(txt)) {
        var row = t.closest('.fqp-titlerow') || t;
        var e = document.createElement('div'); e.className = 'fqp-eyebrow';
        e.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6.5" cy="10" r="1.9"/><circle cx="10" cy="5.8" r="1.9"/><circle cx="14" cy="5.8" r="1.9"/><circle cx="17.5" cy="10" r="1.9"/><path d="M8 17.2c0-2.8 1.8-5.2 4-5.2s4 2.4 4 5.2c0 1.6-1.2 2.3-2.4 2.3-.8 0-1-.4-1.6-.4s-.8.4-1.6.4C9.2 19.5 8 18.8 8 17.2z"/></svg>';
        e.appendChild(document.createTextNode('Unser meistgekaufter Brunnen'));
        row.parentNode.insertBefore(e, row);
      }
      /* Badges ueber dem Titel (11.10.): Trustpilot "Positiv bewertet" + "Premium-Brunnen"; Sterne neben dem Titel entfallen dann */
      var trow = t.closest('.fqp-titlerow') || t;
      var top = document.createElement('div'); top.className = 'fqp-toprow';
      var eb = trow.previousElementSibling && trow.previousElementSibling.classList.contains('fqp-eyebrow') ? trow.previousElementSibling : null;
      trow.parentNode.insertBefore(top, trow);
      if (eb) eb.remove(); /* Nutzer 11.10.: Label 'Unser meistgekaufter Brunnen' weg, nur Badges */
      var st = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#fff" d="m12 2.8 2.7 6.2 6.7.6-5.1 4.4 1.6 6.6L12 17.1l-5.9 3.5 1.6-6.6-5.1-4.4 6.7-.6z"/></svg>';
      var bd = document.createElement('div'); bd.className = 'fqp-tbadges';
      bd.innerHTML = '<span class="fqp-tbadge fqp-tbadge--tp" role="img" aria-label="4,5 von 5 auf Trustpilot"><span class="fqp-tbadge__stars">' + new Array(6).join('<span>' + st + '</span>') + '</span>4,5 von 5 auf Trustpilot</span>' +
        '<span class="fqp-tbadge fqp-tbadge--prem"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 3h11l4 5.5L12 21 2.5 8.5z" fill="#eca841"/><path d="M2.5 8.5h19M9 3 7.5 8.5 12 21l4.5-12.5L15 3" fill="none" stroke="#b86f12" stroke-width="1.3" stroke-linejoin="round"/></svg>Premium-Brunnen</span>';
      top.appendChild(bd);
      /* Nutzer 11.10.: Premium-Badge direkt rechts neben den Titel */
      var pb = bd.querySelector('.fqp-tbadge--prem');
      if (pb && trow !== t) t.insertAdjacentElement('afterend', pb);
      docEl.classList.add('fqp-has-badges');
    }

    /* Alte Buy Box: Preis-Pille im Kaufbutton aus der gewaehlten Kaching-Option (bleibt aktuell) */
    function kbAtcPrice() {
      document.querySelectorAll('#MainContent .kb-atc').forEach(function (btn) {
        if (btn.dataset.fqpPrice) return;
        btn.dataset.fqpPrice = '1';
        var root = btn.closest('.shopify-section') || document;
        var pill = document.createElement('span');
        pill.className = 'kb-atc__price';
        var sync = function () {
          var p = root.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price') || root.querySelector('.kaching-bundles__bar-price') || root.querySelector('[class*="price"]:not(s):not(del)');
          var t = p ? p.textContent.trim() : '';
          if (/\d/.test(t)) { if (pill.textContent !== t) pill.textContent = t; if (!pill.parentNode) btn.appendChild(pill); }
        };
        sync();
        var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(sync, 60); }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });
      });
    }
    function init() { kbAtcPrice(); filterTiles(); heroQuote(); tpStars(); titleStyle(); productPanels(); icons(); faqMore(); menuState(); menuCat(); reveal(); nav(); dropdowns(); warmGrays(); seams(); cats(); footerWave(); onScroll(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

/* 12.10.: Logo im Handy-Menue fuehrt zur Startseite („Home“-Punkt ist ausgeblendet) */
(function () {
  document.addEventListener('click', function (e) {
    var l = e.target && e.target.closest && e.target.closest('[class*="ai-shop-header__mobile-logo-"]');
    if (l) { window.location.href = '/'; }
  });
})();
